import React from 'react';
import { BodySmallText } from '@prisjakt/ui/text/variants';
import { OfferPrices, PricePrice } from 'src/types';
import ShippingLabelComponent from 'src/components/shipping-label';
import { PriceDisplay } from 'src/components/price-list/types';

interface IShippingLabel {
  price?: PricePrice | null;
  offerPrice?: OfferPrices | null;
  priceDisplay: PriceDisplay;
  className?: string;
}

export const ShippingLabel: React.FC<React.PropsWithChildren<
  React.PropsWithChildren<IShippingLabel>
>> = props => {
  const { price, priceDisplay, className } = props;

  if (!price || !price.exclShipping) {
    return null;
  }

  return (
    <BodySmallText className={className}>
      <ShippingLabelComponent
        toneDown
        exclShipping={price.exclShipping}
        inclShipping={price.inclShipping}
        priceDisplay={priceDisplay}
      />
    </BodySmallText>
  );
};
